'use client'

import { Product } from '@/api'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

interface ListingInfoProps {
  conditionTextList: string[]
  product: Product
  className?: string
}

export const ListingInfo = ({
  conditionTextList = [],
  product,
  className = '',
}: ListingInfoProps) => {
  return (
    <div className={className}>
      <Accordion
        type="multiple"
        className="w-full mt-10 py-6 bg-white rounded-lg"
        defaultValue={['condition', 'introduction']}
      >
        <AccordionItem
          value="condition"
          className="border-t border-[#BFBFBF] border-solid"
        >
          <AccordionTrigger hasPlusMinusIcon>
            Condition Details
          </AccordionTrigger>
          <AccordionContent>
            {conditionTextList.map((text, index) => (
              <p key={`condition-${index}`} className="whitespace-pre-wrap">
                {text}
              </p>
            ))}
          </AccordionContent>
        </AccordionItem>

        <AccordionItem
          value="introduction"
          className="border-t border-[#BFBFBF] border-solid"
        >
          <AccordionTrigger hasPlusMinusIcon>
            Product Introduction
          </AccordionTrigger>
          <AccordionContent>
            <p className="whitespace-pre-wrap">
              {product?.productMaster?.description}
            </p>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  )
}
